import { Icon, IconProps } from '~/components/Icon/Icon';

export const D = (props: IconProps) => (
  <Icon width="12" height="12" viewBox="0 0 12 12" fill="none" {...props}>
    <ellipse cx="6" cy="6" rx="6" ry="6" fill="#DDEBFF" />
    <path
      d="M7.87726 4.00867C7.51534 3.67146 7.0972 3.44214 6.61885 3.31856V3.16829C6.61885 2.77861 6.29763 2.46271 5.90138 2.46271C5.50514 2.46271 5.18392 2.77861 5.18392 3.16829V3.20967H4.28572C4.00145 3.20978 3.771 3.43642 3.771 3.71587V8.33132C3.771 8.61089 4.00145 8.83752 4.28572 8.83752H5.18415C5.18415 9.22373 5.50251 9.53682 5.89523 9.53682H5.908C6.30071 9.53682 6.61908 9.22373 6.61908 8.83752V8.72863C7.09742 8.60505 7.51556 8.37584 7.87749 8.03852C8.45219 7.51169 8.73544 6.84446 8.73544 6.03672C8.73544 5.22897 8.45219 4.54413 7.87749 4.00855L7.87726 4.00867ZM5.69499 7.4767H5.18688V4.5706H5.68667C6.62786 4.5706 7.26094 5.15003 7.26094 6.01922C7.26094 6.88842 6.63629 7.4767 5.69511 7.4767H5.69499Z"
      fill="#71ACFF"
    />
  </Icon>
);
